export default "__VITE_ASSET__CTusR6Mb__"